import React, { useLayoutEffect, useRef } from "react";
import { attachGridHeaderCorners, TABLE_TOP_CORNERS } from "./tableHeaderCorners.js";

// For existing custom grid rows; no extra wrapper, scrollport or grid semantics.
export function CornerGridHeader({ style, ...props }) {
  const ref = useRef(null);
  useLayoutEffect(() => attachGridHeaderCorners(ref.current, ref.current?.parentElement), []);
  return <div {...props} ref={ref} style={{ ...style, ...TABLE_TOP_CORNERS }} />;
}
